<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-center">Operaciones</th>
              <th scope="col" class="text-center">Afiche</th>
              <th scope="col" class="text-center">Banner</th>
              <th scope="col" class="text-center">Convocatoria</th>
              <th scope="col" class="text-center">Nro</th>
              <th scope="col" class="text-center">Fecha Solicitud</th>
              <th scope="col" class="text-center">Evento</th>
              <th scope="col" class="text-center">Solicitante/unidad</th>
              <th scope="col" class="text-center">Información</th>
            </tr>
          </thead>
          <tbody v-if="list.length > 0">
            <tr
              v-for="(item, index) in paginatedItems"
              :key="item.id"
              :class="getRowClass(item)"
            >
              <td class="text-center">
                <div v-if="item.inbox > 1">
                  <div
                    class="btn-group btn-sm"
                    role="group"
                    aria-label="Basic example"
                  >
                    <button
                      class="btn btn-primary btn-sm"
                      @click="doAction(item, 3)"
                      title="Aceptar evento"
                    >
                      <i class="fa fa-check"></i>
                    </button>
                    <button
                      class="btn btn-info btn-sm"
                      @click="doAction(item, 4)"
                      title="Observar evento"
                    >
                      <i class="fa fa-question"></i>
                    </button>
                    <button
                      class="btn btn-danger btn-sm"
                      @click="doAction(item, 5)"
                      title="Rechazar evento"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
                <div v-else>
                  <button
                    class="btn btn-primary"
                    @click="doAction(item, 2)"
                    title="Recepcionar evento"
                  >
                    Recepcionar
                  </button>
                </div>
              </td>

              <td class="text-center">
                <button
                  class="btn btn-secondary btn-sm"
                  type="button"
                  @click="loadModal(item, 'Afiche', 'poster')"
                  :disabled="item.inbox == 1"
                  title="Revisar afiche"
                >
                  <i class="fa fa-upload"></i>
                </button>
              </td>
              <td class="text-center">
                <button
                  class="btn btn-success btn-sm"
                  type="button"
                  @click="loadModal(item, 'Banner', 'banner')"
                  :disabled="item.inbox == 1"
                  title="Revisar banner"
                >
                  <i class="fa fa-upload"></i>
                </button>
              </td>
              <td class="text-center">
                <button
                  class="btn btn-primary btn-sm"
                  type="button"
                  @click="openReglamento(item)"
                  title="Ver convocatoria en PDF"
                  :disabled="item.inbox == 1"
                >
                  <i class="fa fa-eye"></i>
                </button>
              </td>

              <th scope="row" class="text-center">{{ item.id }}</th>
              <td class="text-center">{{ formatDate(item.updated_at) }}</td>
              <td class="text-center" style="max-width: 250px">
                {{ item.title }}
              </td>
              <td class="text-center">
                <div style="font-weight: bold; padding: 0">
                  {{ item.user }}
                </div>
                <div style="padding: 0">
                  {{ item.unity }}
                </div>
              </td>
              <td class="text-center">
                <div class="btn-group">
                  <button
                    class="btn btn-info btn-sm"
                    type="button"
                    @click="showEventInfo(item)"
                    title="Ver información del evento"
                  >
                    <i class="fa fa-info-circle"></i>
                  </button>
                  <button
                    v-if="item.conflictData && item.conflictData.hasConflicts"
                    class="btn btn-sm"
                    :class="getConflictButtonClass(item.conflictData)"
                    @click="showConflicts(item)"
                    title="Ver conflictos"
                  >
                    <i class="fa fa-exclamation-triangle"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
          <tr v-else>
            <td colspan="9">
              <EmptyState
                title="No hay eventos recibidos."
                :size="450"
                fontSize="fs-5"
              />
            </td>
          </tr>
        </table>
      </div>
      <pagination
        :totalItems="list.length"
        :itemsPerPage="itemsPerPage"
        @page-change="handlePageChange"
      />
    </div>
  </div>
  <UpdateFileModal
    ref="thisModal"
    :name="modalName"
    :event="eventSelect"
    :mode="modalMode"
    @reloadList="loadItems"
  />
  <EventInfoModal ref="eventInfoModal" :event="selectedEventInfo" />
  <ReviewModal
    ref="reviewModal"
    :event="eventSelect"
    :actionType="currentReviewAction"
    @reviewSubmitted="handleReviewSubmitted"
  />
  <PdfViewModal ref="pdfModal" :event="eventSelect" source="regulation" />
  <ConflictsModal
    ref="conflictsModal"
    :event="selectedEventForConflicts"
    :conflicts="selectedConflicts"
  />
</template>

<script setup>
import UpdateFileModal from "./UpdateFileModal.vue";
import EventInfoModal from "./EventInfoModal.vue";
import { onMounted, ref, inject, computed } from "vue";
import axios from "@/includes/connection";
import { toast } from "vue3-toastify";
import ReviewModal from "./ObservationModal.vue";
import Pagination from "@/pages/components/Pagination.vue";
import PdfViewModal from "./PreviewPdfModal.vue";
import ConflictsModal from "./ConclictModal.vue";
import EmptyState from "@/components/emptyState.vue";
const list = ref([]);
const recive = ref({ 2: "recibir" });
const accion = ref({ 3: "Aprobar", 4: "Observar", 5: "Rechazar" });
const emit = defineEmits(["traffic-light-update"]);

const swal = inject("$swal");

let thisModal = ref(null);
let eventInfoModal = ref(null);
let pdfModal = ref(null);
let conflictsModal = ref(null);

onMounted(() => {
  loadItems();
});

const eventSelect = ref({});
const selectedEventInfo = ref({});
const selectedEventForConflicts = ref({});
const selectedConflicts = ref([]);
const modalName = ref();
const modalMode = ref();
const observationModal = ref(null);
const currentReviewAction = ref(4);
const reviewModal = ref(null);

function loadModal(event, name, mode) {
  thisModal.value.show();
  //console.log("mostrando modal de : ", event);
  eventSelect.value = event;
  modalName.value = name;
  modalMode.value = mode;
}

function openReglamento(item) {
  eventSelect.value = item;
  pdfModal.value.show();
}

function showEventInfo(event) {
  //console.log("Informacion del evento a revisar:", event);
  selectedEventInfo.value = event;
  eventInfoModal.value.show();
}

function showConflicts(event) {
  selectedEventForConflicts.value = event;
  selectedConflicts.value = event.conflictData?.conflicts || [];
  conflictsModal.value.show();
}

function formatDate(dateString) {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("fr-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

function getRowClass(item) {
  if (item.inbox <= 1) return "";

  if (!item.conflictData) return "";

  if (!item.conflictData.hasConflicts) return "";

  const conflicts = item.conflictData.conflicts || [];
  const hasCritical = conflicts.some((c) => c.severity === "error");
  const hasWarning = conflicts.some((c) => c.severity === "warning");

  if (hasCritical) return "table-danger";
  if (hasWarning) return "table-warning";
  return "table-info";
}

function getConflictButtonClass(conflictData) {
  if (!conflictData.hasConflicts) return "btn-success";

  const conflicts = conflictData.conflicts || [];
  const hasCritical = conflicts.some((c) => c.severity === "error");
  const hasWarning = conflicts.some((c) => c.severity === "warning");

  if (hasCritical) return "btn-danger";
  if (hasWarning) return "btn-warning";
  return "btn-info";
}

async function checkEventConflicts(event) {
  if (event.inbox <= 1) return;

  try {
    event.checkingConflicts = true;
    const response = await axios.get(`/event/conflicts/${event.id}`);
    event.conflictData = response.data;
  } catch (error) {
    //console.error(`Error checking conflicts for event ${event.id}:`, error);
    event.conflictData = {
      hasConflicts: false,
      message: "Error verificando conflictos",
      conflicts: [],
    };
  } finally {
    event.checkingConflicts = false;
  }
}

async function checkAllConflicts() {
  const receivedEvents = list.value.filter((event) => event.inbox > 1);
  const promises = receivedEvents.map((event) => checkEventConflicts(event));
  await Promise.all(promises);
}

function loadItems() {
  axios
    .get("/event/comunicacion")
    .then(async (response) => {
      //console.log("list", response.data);
      if (response.data) {
        list.value = response.data;
        await checkAllConflicts();
        setTimeout(() => {
          const now = new Date();
          const counter = { rojo: 0, amarillo: 0, verde: 0, azul: 0 };

          list.value.forEach((event) => {
            if (event.received_at) {
              const receivedDate = new Date(event.received_at);
              const daysDiff = Math.floor(
                (now - receivedDate) / (1000 * 60 * 60 * 24)
              );

              if (daysDiff > 10) {
                counter.rojo++;
                //console.log("mas de 10 dias", counter.rojo)
              } else if (daysDiff >= 5) {
                counter.amarillo++;
                //console.log("mas de 5 dias", counter.amarillo)
              } else {
                counter.verde++;
                //console.log("de 0 a 4 dias", counter.verde)
              }
            } else {
              counter.azul++;
              //console.log("no recepcionados", counter.azul)
            }
          });
          //console.log("totales", counter)
          emit("traffic-light-update", counter);
        }, 100);
      }
    })
    .catch(function (error) {
      console.log(error);
    });
}

const recibeAction = ref([{ id: 2, name: "Recibir" }]);

const actionList = ref([
  { id: 3, name: "Aprobar" },
  { id: 4, name: "Observar" },
  { id: 5, name: "Rechazar" },
]);

const doAction = (event, doAction) => {
  console.log("this is an action", doAction);

  if (doAction === 4 || doAction === 5) {
    currentReviewAction.value = doAction;
    eventSelect.value = event;
    reviewModal.value.show();
    return;
  }

  if (doAction === 3) {
    const hasPoster = !!event.poster;
    const hasBanner = !!event.banner;
    const hasRegulation = !!event.regulation;

    if (!hasPoster || !hasBanner || !hasRegulation) {
      swal.fire({
        title: "Archivos Faltantes",
        text: "Para aprobar el evento, debe tener cargados el Afiche y el Banner correspondiente.",
        icon: "error",
      });
      return;
    }
  }

  if (event.conflictData && event.conflictData.hasConflicts) {
    const hasCriticalConflicts = event.conflictData.conflicts.some(
      (c) => c.severity === "error"
    );
    if (hasCriticalConflicts) {
      swal
        .fire({
          title: "Conflicto Crítico Detectado",
          text: "Este evento tiene conflictos críticos (mismo día, hora y lugar). ¿Desea aprobar de todas formas?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Proceder a la aprobación",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            executeAction(event, doAction);
          }
        });
      return;
    }
  }

  if (event.conflictData && event.conflictData.hasConflicts) {
    const hasCriticalConflicts = event.conflictData.conflicts.some(
      (c) => c.severity === "warning"
    );
    if (hasCriticalConflicts) {
      swal
        .fire({
          title: "Conflicto Alto Detectado",
          text: "Este evento tiene conflictos altos (mismo día y lugar pero diferente hora). ¿Desea aprobar de todas formas?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Proceder a la aprobación",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            executeAction(event, doAction);
          }
        });
      return;
    }
  }

  executeAction(event, doAction);
};

const handleReviewSubmitted = (obsData) => {
  console.log("Review submitted:", obsData);

  const dataJson = {
    event_id: obsData.event.id,
    step_id: 1,
    action_id: obsData.actionType,
    state: 1,
    comment: obsData.comment,
  };

  axios
    .patch(`/event/${obsData.event.id}/detail`, { detail: obsData.comment })
    .then(() => {
      return axios.post("/flow-event", dataJson);
    })
    .then((response) => {
      console.log("response", response);
      loadItems();
      const actionName = obsData.actionType === 4 ? "observado" : "rechazado";
      toast.success(`Evento ${actionName} exitosamente!`);
    })
    .catch(function (error) {
      console.error("Error:", error);
      toast.error("Error al procesar la revisión!");
    });
};

const executeAction = (event, actionId) => {
  const dataJson = {
    event_id: event.id,
    step_id: 1,
    action_id: actionId,
    state: 1,
  };

  if (actionId === 3) {
    swal
      .fire({
        title: "¿Está seguro?",
        text: "Se aprobará un nuevo evento.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Registrar",
        cancelButtonText: "Cancelar",
      })
      .then((result) => {
        if (result.isConfirmed) {
          axios
            .post("/flow-event", dataJson)
            .then((response) => {
              console.log("response", response);
              loadItems();
              let msg = "";
              if (actionId === 2) {
                msg = "Recepción exitosa!";
              } else if (actionId === 3) {
                msg = "Registro exitoso!";
              } else {
                msg = "Recepcionado!!";
              }
              toast.success(msg);
            })
            .catch(function (error) {
              toast.error("Registro Fallido!");
              console.error("Error:", error);
            });
        }
      })
      .catch(function (error) {
        console.error("error", error);
        toast.error("Error al aprobar evento");
      });
  } else {
    axios
      .post("/flow-event", dataJson)
      .then((response) => {
        console.log("response", response);
        loadItems();
        let msg = "";
        if (actionId === 2) {
          msg = "Recepción exitosa!";
        } else if (actionId === 3) {
          msg = "Registro exitoso!";
        } else {
          msg = "Recepcionado!!";
        }
        toast.success(msg);
      })
      .catch(function (error) {
        toast.error("Registro Fallido!");
        console.error("Error:", error);
      });
  }
};

let currentPage = ref(1);
let itemsPerPage = ref(10);

let paginatedItems = computed(() => {
  const startIndex = (currentPage.value - 1) * itemsPerPage.value;
  const endIndex = startIndex + itemsPerPage.value;
  return list.value.slice(startIndex, endIndex);
});

function handlePageChange(page) {
  currentPage.value = page;
}
</script>

<style scoped>
.table-success {
  background-color: #d1edff !important;
}

.table-warning {
  background-color: #fff3cd !important;
}

.table-danger {
  background-color: #f8d7da !important;
}

.table-info {
  background-color: #d1ecf1 !important;
}

.btn-sm {
  font-size: 0.75rem;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
}

.fa-spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
